var _style, _g, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVrtsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331.5 164",
    style: {
      enableBackground: "new 0 0 331.5 164"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#01FFFF;}\r\n\t.st2{fill:#283940;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40,129.2h-0.6l-4.1-9.3h0.8l3.6,8.5l3.6-8.5H44L40,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.2,120.6v-0.9H48v0.9H47.2z M47.3,129.1v-6.7h0.6v6.7H47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,123c-1.6,0-2.9,1.2-2.9,3.4v2.8h-0.6v-6.7h0.6v1.9c0.5-1.2,1.6-2.1,3-2L55.6,123L55.6,123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.2,129.2c-1,0-1.9-0.6-1.9-1.8V123h-1v-0.6h1v-2.1h0.6v2.1h2.4v0.6h-2.4v4.3c0,1,0.6,1.3,1.3,1.3 c0.3,0,0.6-0.1,1-0.2v0.6C61.9,129.1,61.6,129.2,61.2,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.8,129.1v-1.3c-0.4,0.8-1.2,1.4-2.4,1.4c-1.7,0-2.7-1.2-2.7-2.8v-4.1h0.6v4c0,1.4,0.8,2.3,2.1,2.3 c1.3,0,2.3-1,2.3-2.4v-3.9h0.6v6.7H70.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80.1,129.1V128c-0.5,0.6-1.3,1.3-2.6,1.3c-1.3,0-2.6-0.7-2.6-2.1v0c0-1.4,1.2-2.2,2.9-2.2 c0.9,0,1.6,0.1,2.2,0.3v-0.3c0-1.4-0.8-2.1-2.2-2.1c-0.8,0-1.5,0.2-2.1,0.5l-0.2-0.6c0.7-0.3,1.5-0.6,2.4-0.6 c1.7,0,2.8,0.9,2.8,2.6v4.2H80.1z M80.1,125.8c-0.6-0.1-1.3-0.3-2.3-0.3c-1.4,0-2.2,0.6-2.2,1.6v0c0,1,0.9,1.5,1.9,1.5 c1.4,0,2.5-0.8,2.5-2.1V125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M84.8,129.1v-9.6h0.6v9.6H84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,129.1l-2.9-3.8h-3v3.8h-0.7v-9.2h3.9c2,0,3.3,1.1,3.3,2.6v0c0,1.5-1.1,2.4-2.7,2.6l3,3.9H101.9z  M101.7,122.5c0-1.2-1-2-2.6-2H96v4.1h3.1C100.6,124.6,101.7,123.9,101.7,122.5L101.7,122.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109,128.6c1,0,1.8-0.5,2.3-1.1l0.4,0.4c-0.7,0.7-1.5,1.3-2.8,1.3c-1.8,0-3.3-1.4-3.3-3.5v0 c0-1.9,1.4-3.5,3.2-3.5c1.9,0,3.1,1.5,3.1,3.5v0c0,0.1,0,0.1,0,0.2h-5.6C106.5,127.7,107.7,128.6,109,128.6z M111.2,125.4 c-0.1-1.4-0.9-2.6-2.4-2.6c-1.3,0-2.4,1.1-2.5,2.6H111.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120,129.1V128c-0.5,0.6-1.3,1.3-2.6,1.3c-1.3,0-2.6-0.7-2.6-2.1v0c0-1.4,1.2-2.2,2.9-2.2 c0.9,0,1.6,0.1,2.2,0.3v-0.3c0-1.4-0.8-2.1-2.2-2.1c-0.8,0-1.5,0.2-2.1,0.5l-0.2-0.6c0.7-0.3,1.5-0.6,2.4-0.6 c1.7,0,2.8,0.9,2.8,2.6v4.2H120z M120.1,125.8c-0.6-0.1-1.3-0.3-2.3-0.3c-1.4,0-2.2,0.6-2.2,1.6v0c0,1,0.9,1.5,1.9,1.5 c1.4,0,2.5-0.8,2.5-2.1V125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.7,129.1v-9.6h0.6v9.6H124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,120.6v-0.9h0.8v0.9H129.5z M129.6,129.1v-6.7h0.6v6.7H129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.6,129.2c-1,0-1.9-0.6-1.9-1.8V123h-1v-0.6h1v-2.1h0.6v2.1h2.4v0.6h-2.4v4.3c0,1,0.6,1.3,1.3,1.3 c0.3,0,0.6-0.1,1-0.2v0.6C137.4,129.1,137,129.2,136.6,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.3,129.3c-0.6,1.4-1.3,1.9-2.2,1.9c-0.5,0-0.9-0.1-1.3-0.3l0.2-0.6c0.4,0.2,0.6,0.3,1.1,0.3 c0.7,0,1.2-0.4,1.7-1.6l-3.2-6.7h0.8l2.8,6l2.4-6h0.7L144.3,129.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.6,120.5v8.6h-0.7v-8.6h-3.2v-0.6h7.1v0.6H159.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.6,123c-1.6,0-2.9,1.2-2.9,3.4v2.8H165v-6.7h0.6v1.9c0.5-1.2,1.6-2.1,3-2L168.6,123L168.6,123z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.2,129.1V128c-0.5,0.6-1.3,1.3-2.6,1.3c-1.3,0-2.6-0.7-2.6-2.1v0c0-1.4,1.2-2.2,2.9-2.2 c0.9,0,1.6,0.1,2.2,0.3v-0.3c0-1.4-0.8-2.1-2.2-2.1c-0.8,0-1.5,0.2-2.1,0.5l-0.2-0.6c0.7-0.3,1.5-0.6,2.4-0.6 c1.7,0,2.8,0.9,2.8,2.6v4.2H176.2z M176.2,125.8c-0.6-0.1-1.3-0.3-2.3-0.3c-1.4,0-2.2,0.6-2.2,1.6v0c0,1,0.9,1.5,1.9,1.5 c1.4,0,2.5-0.8,2.5-2.1V125.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M180.7,120.6v-0.9h0.8v0.9H180.7z M180.8,129.1v-6.7h0.6v6.7H180.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.7,129.1v-4c0-1.4-0.8-2.3-2.1-2.3c-1.3,0-2.3,1-2.3,2.4v3.9h-0.6v-6.7h0.6v1.3c0.4-0.8,1.2-1.4,2.4-1.4 c1.7,0,2.7,1.2,2.7,2.8v4.1H190.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.3,120.6v-0.9h0.8v0.9H195.3z M195.4,129.1v-6.7h0.6v6.7H195.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.3,129.1v-4c0-1.4-0.8-2.3-2.1-2.3c-1.3,0-2.3,1-2.3,2.4v3.9h-0.6v-6.7h0.6v1.3c0.4-0.8,1.2-1.4,2.4-1.4 c1.7,0,2.7,1.2,2.7,2.8v4.1H205.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.8,131.2c-1.1,0-2.2-0.3-3.1-1l0.4-0.5c0.8,0.6,1.7,0.9,2.7,0.9c1.5,0,2.6-0.9,2.6-2.6v-1 c-0.6,0.8-1.5,1.6-2.8,1.6c-1.6,0-3.2-1.2-3.2-3.2v0c0-1.9,1.6-3.2,3.2-3.2c1.3,0,2.3,0.7,2.8,1.5v-1.3h0.6v5.7 C216.1,130.1,214.7,131.2,212.8,131.2z M215.5,125.4c0-1.6-1.4-2.6-2.8-2.6c-1.4,0-2.6,1-2.6,2.5v0c0,1.5,1.2,2.6,2.6,2.6 C214.1,128,215.5,126.9,215.5,125.4L215.5,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229,129.2c-1.5,0-2.6-0.5-3.7-1.5l0.4-0.5c1,0.9,1.9,1.4,3.3,1.4c1.4,0,2.3-0.8,2.3-1.8v0c0-1-0.5-1.5-2.6-2 c-2.2-0.4-3.1-1.2-3.1-2.6v0c0-1.4,1.3-2.4,3-2.4c1.3,0,2.2,0.4,3.2,1.1l-0.4,0.5c-0.9-0.7-1.7-1-2.8-1c-1.4,0-2.3,0.8-2.3,1.7v0 c0,1,0.5,1.6,2.7,2c2.1,0.4,3,1.2,3,2.5v0C232.1,128.2,230.8,129.2,229,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.8,129.2c-2,0-3.4-1.6-3.4-3.5v0c0-1.9,1.5-3.5,3.5-3.5c2,0,3.4,1.6,3.4,3.5v0 C242.2,127.6,240.8,129.2,238.8,129.2z M241.5,125.7c0-1.6-1.2-2.9-2.8-2.9c-1.6,0-2.7,1.3-2.7,2.9v0c0,1.6,1.2,2.9,2.8,2.9 C240.4,128.6,241.5,127.3,241.5,125.7L241.5,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.9,129.1v-9.6h0.6v9.6H245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M255.7,129.1v-1.3c-0.4,0.8-1.2,1.4-2.4,1.4c-1.7,0-2.7-1.2-2.7-2.8v-4.1h0.6v4c0,1.4,0.8,2.3,2.1,2.3 c1.3,0,2.3-1,2.3-2.4v-3.9h0.6v6.7H255.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.6,129.2c-1,0-1.9-0.6-1.9-1.8V123h-1v-0.6h1v-2.1h0.6v2.1h2.4v0.6h-2.4v4.3c0,1,0.6,1.3,1.3,1.3 c0.3,0,0.6-0.1,1-0.2v0.6C263.4,129.1,263.1,129.2,262.6,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.3,120.6v-0.9h0.8v0.9H267.3z M267.4,129.1v-6.7h0.6v6.7H267.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M275.1,129.2c-2,0-3.4-1.6-3.4-3.5v0c0-1.9,1.5-3.5,3.5-3.5c2,0,3.4,1.6,3.4,3.5v0 C278.6,127.6,277.1,129.2,275.1,129.2z M277.9,125.7c0-1.6-1.2-2.9-2.8-2.9c-1.6,0-2.7,1.3-2.7,2.9v0c0,1.6,1.2,2.9,2.8,2.9 C276.8,128.6,277.9,127.3,277.9,125.7L277.9,125.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287.3,129.1v-4c0-1.4-0.8-2.3-2.1-2.3c-1.3,0-2.3,1-2.3,2.4v3.9h-0.6v-6.7h0.6v1.3c0.4-0.8,1.2-1.4,2.4-1.4 c1.7,0,2.7,1.2,2.7,2.8v4.1H287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.1,129.2c-1,0-2-0.4-2.8-1l0.4-0.5c0.7,0.6,1.6,0.9,2.4,0.9c0.9,0,1.6-0.5,1.6-1.3v0 c0-0.8-0.8-1.1-1.8-1.3c-1.1-0.3-2.3-0.6-2.3-1.8v0c0-1.1,0.9-1.9,2.2-1.9c0.8,0,1.7,0.3,2.4,0.7l-0.3,0.5 c-0.6-0.4-1.4-0.7-2.1-0.7c-0.9,0-1.5,0.5-1.5,1.2v0c0,0.8,0.9,1,1.9,1.3c1.1,0.3,2.2,0.7,2.2,1.9v0 C296.4,128.5,295.4,129.2,294.1,129.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.2,49.2c0-8-6.5-14.5-14.5-14.5h-5.2c-0.5,0-1.1,0-1.6,0.1c-37.2-0.2-74.4-0.2-111.6-0.1 c-0.2,0-0.5,0-0.7,0h-5.2c-8,0-14.5,6.5-14.5,14.5c-0.1,0-0.2,37.4-0.2,37.4c0,10.2,8.3,18.6,18.5,18.7h0c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0h6.5c0.1,0,0.1,0,0.2,0c10,0,20.1-0.1,30.1,0c4.2,0,7.2-1.7,8.7-5.6c2.2-5.8,5.7-9.8,12.3-9.8c6.4,0,9.9,4.2,12,9.6 c1.6,4.2,4.6,5.9,9,5.8c7-0.1,14-0.1,21,0h15.8v0c0.1,0,0.1,0,0.2,0c10.3,0,18.7-8.4,18.7-18.7L188.2,49.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.4,87.5l-10.6-13.8h-10.9v13.8h-2.5V54.2h14c7.2,0,11.9,3.9,11.9,9.5v0.1c0,5.6-4.1,8.8-9.8,9.5l11,14.2 H158.4z M157.8,63.8c0-4.5-3.5-7.3-9.6-7.3h-11.4v15h11.2C153.6,71.5,157.8,68.7,157.8,63.8L157.8,63.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.2,88h-2.2L58.4,54.4h2.8l13,30.7l13.1-30.7h2.6L75.2,88z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.3,56.5v31h-2.5v-31h-11.6v-2.3h25.7v2.3H217.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.2,88c-5.3,0-9.4-1.8-13.4-5.3l1.6-1.9c3.7,3.4,7,5,12,5c5,0,8.4-2.8,8.4-6.6v-0.1c0-3.5-1.9-5.6-9.4-7.1 c-8-1.6-11.2-4.3-11.2-9.4v-0.1c0-5,4.5-8.8,10.7-8.8c4.9,0,8,1.3,11.4,4l-1.6,2c-3.1-2.7-6.3-3.8-10-3.8c-4.9,0-8.1,2.8-8.1,6.3 v0.1c0,3.5,1.8,5.7,9.7,7.3c7.7,1.6,11,4.3,11,9.2v0.1C296.3,84.3,291.7,88,285.2,88z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVrtsLogo);
export default __webpack_public_path__ + "static/media/VRTS_Logo.4589bdf1188390d44ad4dc8400cdf3c0.svg";
export { ForwardRef as ReactComponent };